import React from 'react';
import { useLocation } from 'react-router';

import HomeworkForm from 'Components/HomeworkForm';

export default function HomeworkUpdate() {
  const location = useLocation();

  return (
    <div>
      <HomeworkForm updateId={location.state.hwId} />
    </div>
  );
}
